var app = angular.module("leonardo");

var TaskActions = function($scope, $state, ngDialog, PermissionService, AccountUserService) {

  $scope.permissionService = PermissionService;

  $scope.accountUserService = AccountUserService;

  $scope.showTaskReportDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/task/report.html',
      controller: 'TaskReportDialog',
      className: 'ngdialog-theme-default ngdialog-task-report'
    });
  };

  $scope.showTaskUnitReportDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/task/report_unit.html',
      controller: 'TaskUnitReportDialog',
      className: 'ngdialog-theme-default ngdialog-task-report'
    });
  };

  $scope.quickAddTask = function() {
    if ($state.$current.name === 'owner-tasks.tasks') {
      $state.go('owner-tasks.templates.add', {origin:'task'});
    }
    else {
      $state.go('property.templates.add', {origin:'task'});
    }
  };

};

app.controller('TaskActions', ['$scope', '$state', 'ngDialog', 'PermissionService', 'AccountUserService', TaskActions]);
